

// eslint-disable-next-line
export const createAddObjectKey = function(struct, keyName) {
  return function(obj) {
    const keyValue = obj[keyName];
    // eslint-disable-next-line no-param-reassign
    struct[keyValue] = obj;
  };
};


export const objPropsToPixels = function(obj) {
  const result = {};
  Object.entries(obj)
    .forEach(function([key, value]) {
      result[key] = `${value}px`;
    });
  return result;
};

/*
  https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
  https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array/12646864#12646864
*/
export const shuffleArray = function(array) {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // eslint-disable-line no-param-reassign
  }
  return array;
};


/*
  return an array of records
  grouped by number and shuffled
*/
export const groupAndShuffleArticleRecords = function(records) {
  // struct to organize arrays for each group
  const struct = {
    /*
      '1': [],
      '2': [],
      ...
    */
  };

  records.forEach((article) => {
    const { group } = article;
    const key = parseInt(group, 10);
    const arr = struct[key] || [];
    arr.push(article);
    struct[key] = arr;
  });

  /*
    loop through sorted group IDs
    shuffle array
    push results to master arry
  */
  let articles = [];
  Object.keys(struct).sort()
    .forEach((key) => {
      const arr = struct[key];
      shuffleArray(arr);
      articles = articles.concat(arr);
    });

  return articles;
};



// WEBPACK FOOTER //
// ./src/utils/data-utils.js